import onBottomScroll from '@vue-storefront/core/mixins/onBottomScroll'
export default {
    name: 'UserComplaints',
    mixins: [onBottomScroll],
    data () {
      return {
        pagination: {
          perPage: 100,
          current: 1,
          enabled: false
        },
        lazyLoadOrdersOnScroll: true
      }
    },
    computed: {
        complaints () {
          let items = this.$store.state.user.complaints ? this.$store.state.user.complaints.results : []
          return items;
      },
      isComplaintsListEmpty () {
        return this.$store.state.user.complaints && this.$store.state.user.complaints.results && this.$store.state.user.complaints.results.length < 1
      }
    },
    methods: {
      onBottomScroll () {
        ++this.pagination.current
      }
    }
  }
  